import { AxiosResponse } from "axios";
import { axiosPrivate } from "./axios";

export const getAddress = async () => {
  const response = await axiosPrivate.get('/api/address/deliver/list');
  return response.data;
}

export const createAddress = async (data: any): Promise<AxiosResponse> => {
  return await axiosPrivate.post('/api/address/create', JSON.stringify(data));
}

export const removeAddress = async (data: any): Promise<AxiosResponse> => {
  return await axiosPrivate.post('/api/address/remove', JSON.stringify(data));
}

export const updateDefaultAddress = async (data: any): Promise<AxiosResponse> => {
  return await axiosPrivate.post('/api/address/default/update', JSON.stringify(data));
}